import { component } from 'picoapp'

export default component((node) => {
  function sendEvent() {
    const eventName = node.dataset.eventName
    const eventDetail = node.dataset?.eventDetail || ''

    if (window.gtag) {
      window.gtag('event', eventName, { event_detail: eventDetail })
    }
  }

  node.addEventListener('click', sendEvent)

  return () => {
    node.removeEventListener('click', sendEvent)
  }
})
